// Generated by scripts/update-seeq-icons.js from src/svg/seeq/gear.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcGear = {
  prefix: 'fak',
  iconName: 'gear' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e945',
    'M931.8 563.2c5.1-41 5.1-81.9 0-122.9l87.1-81.9c-10.2-41-30.7-81.9-51.2-117.8l-122.9 10.3c-25.6-30.7-56.3-61.4-87-81.9l5.1-122.9c-10.2-5.1-25.6-15.4-41-20.5-25.6-10.2-51.2-20.5-81.9-25.6l-76.8 92.2c-41-5.1-81.9-5.1-122.9 0l-76.8-87.1c-41 10.2-81.9 30.7-117.7 51.2l10.2 122.9c-35.8 20.5-66.6 51.2-87 87l-122.9-5.1c-5.1 10.2-15.4 25.6-20.5 35.9-10.2 30.7-20.5 56.3-25.6 81.9l92.2 81.9c-5.1 41-5.1 81.9 0 122.9l-87.1 81.9c10.2 41 30.7 81.9 51.2 117.8l122.9-10.3c25.6 30.7 56.3 61.4 87 81.9l-5.1 122.9c10.2 5.1 25.6 15.4 41 20.5 25.6 10.2 51.2 20.5 81.9 25.6l76.8-92.2c41 5.1 81.9 5.1 122.9 0l81.9 87.1c41-10.2 81.9-30.7 117.8-51.2l-10.3-122.9c30.7-25.6 61.4-56.3 81.9-87l122.9 5.1c5.1-10.2 15.4-25.6 20.5-41 10.2-25.6 20.5-51.2 25.6-81.9l-92.2-76.8zM512 737.3c-122.9 0-225.3-102.4-225.3-225.3s102.4-225.3 225.3-225.3 225.3 102.4 225.3 225.3c0 122.9-102.4 225.3-225.3 225.3z',
  ],
} satisfies IconDefinition;
